import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/ziauddin-sayyed" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://in.linkedin.com/in/sayyed-ziauddin-24aab67a" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <p>A portfolio designed & built by <a href="https://github.com/ziauddin-sayyed" target="_blank" rel="noreferrer">Sayyed Ziyauddin</a> with 💜</p>
    </footer>
  );
}

export default Footer;